import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const markdownComponents = {
  a: ({ href, children }) => (
    <a href={href} target={href?.startsWith('http') ? '_blank' : undefined} rel="noreferrer">
      {children}
    </a>
  ),
  img: ({ src, alt }) => (
    <figure className="chat-figure">
      <img src={src} alt={alt || ''} />
      {alt ? <figcaption>{alt}</figcaption> : null}
    </figure>
  ),
};

const ChatMessages = ({ messages }) => (
  <div className="chat-messages" aria-live="polite">
    {messages.map((message) => (
      <article key={message.id} className={`chat-message chat-message-${message.role}`}>
        <div className="chat-message-role">
          {message.role === 'user' ? 'You' : (
            <>
              <img src="/chat-logo.png" alt="" className="chat-avatar" />
              CoralFuture AI
            </>
          )}
        </div>
        <div className="chat-message-body">
          {Array.isArray(message.attachments) && message.attachments.length > 0 && (
            <div className="chat-message-attachments">
              {message.attachments.map((attachment) => (
                attachment.isImage ? (
                  <a key={attachment.id || attachment.url} href={attachment.url} className="chat-attachment-image">
                    <img src={attachment.url} alt={attachment.originalName || 'attachment'} />
                  </a>
                ) : (
                  <a key={attachment.id || attachment.url} href={attachment.url} className="chat-attachment-file">
                    {attachment.originalName || 'attachment'}
                  </a>
                )
              ))}
            </div>
          )}
          <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents}>
            {message.content || ''}
          </ReactMarkdown>
          {Array.isArray(message.links) && message.links.length > 0 && !message.streaming && (
            <div className="chat-links">
              {message.links.map((link) => (
                <a key={link.href} href={link.href} className={`chat-link chat-link-${link.type || 'link'}`}>
                  {link.label || link.href}
                </a>
              ))}
            </div>
          )}
        </div>
      </article>
    ))}
  </div>
);

export default ChatMessages;
